import React from "react";
import { useNavigate } from "react-router-dom";
import { Moon, Sun, Receipt } from "lucide-react";
import { useTheme } from "../context/ThemeProvider";

export const Header = ({ subtitle }) => {
  const { theme, toggle } = useTheme();
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-40 glass bg-background/70 border-b border-border">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
        <button
          data-testid="logo-home-button"
          onClick={() => navigate("/")}
          className="flex items-center gap-2 active:scale-95 transition-transform"
        >
          <span className="w-9 h-9 rounded-xl bg-primary text-primary-foreground flex items-center justify-center">
            <Receipt size={18} />
          </span>
          <div className="text-left leading-none">
            <span className="font-display font-extrabold text-lg tracking-tight">SplitBon</span>
            {subtitle && <p className="text-[11px] text-muted-foreground mt-0.5">{subtitle}</p>}
          </div>
        </button>
        <button
          data-testid="theme-toggle"
          onClick={toggle}
          className="w-10 h-10 rounded-full bg-secondary flex items-center justify-center active:scale-90 transition-transform"
          aria-label="Schimbă tema"
        >
          {theme === "dark" ? <Sun size={18} /> : <Moon size={18} />}
        </button>
      </div>
    </header>
  );
};
